
<ng-container *ngFor="let policy of policyDetails">
  <ng-container *ngIf="policy?.policynumber.policyNumber === policyId">
    <mapfre-alert></mapfre-alert>
    <header class="margin-bottom mb16">
      <div class="type-title">
        <h1 class="title">
          {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
        </h1>
        <div class="sub-title">{{ policy?.displayType?.label }} - <strong>{{ policy?.policynumber.policyNumber }}</strong></div>
      </div>
    </header>
    <section class="row policy-details-content no-margin-horizontal details-content" >
      <div class="col col1 no-padding-left">  
      <div class="header-icon margin-bottom mb24 text-center">
            <svg-important-message-svg></svg-important-message-svg>
            <h2 class="title-copy text-center margin-top mt16 error-message-payment">
              {{ 'Unable to process any additional payments' }}
            </h2>
            <h6 class="title-copy text-center grey-color confirm-payment error-help-font">
                {{ 'Online payment is not available for this policy' }}
                <ng-container *ngIf="errorCode===06">{{ 'at this time,' }} <div>{{ 'please try again tomorrow.' }}</div></ng-container>
            </h6>
            <h6 class="title-copy text-center grey-color confirm-payment error-help-font">
              <ng-container *ngIf="errorCode===06">{{ 'If you need personal assistance,' }}</ng-container>
              <div>{{ 'Please contact our Customer Service Department at' }} </div>
              <div><a href="tel:18009228276" class="underline">1-800-922-8276</a> </div>
              <div class="info">{{ 'CONTACT_CENTER_HOURS' | translate }}</div>
              <div class="info">{{ 'CONTACT_CENTER_HOURS_2' | translate }}</div>
          </h6>

        </div>  

        <div class="text-center margin-top mt24">
            <a class="mapfre link blue-link"
            [routerLink]="['/my-insurance/'+policyId+'/billing']">
               <strong> {{ 'GO TO BILLING' }} </strong>
            </a>
        </div>       
      </div>
      <div class="col col2">
        <app-billing-sidebar [policy]="policy"></app-billing-sidebar>
      </div>
    </section>
  </ng-container>
</ng-container>
